import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { IQuestionnaireAnswer, QuestionnaireAnswer } from '../QuestionnaireAnswer.ts';
import { QuestionnaireAnswerApi } from '../../../apis/QuestionnaireAnswerApi/QuestionnaireAnswerApi.ts';
import { useIdFromRoute } from '../../../hooks/useIdFromRoute.tsx';
import { useBaseQuery } from '../../../queryDefaults/baseQueries/useBaseQuery.tsx';

export function useGetQuestionnaireAnswerByTaskId() {
    const id = useIdFromRoute();
    return useBaseQuery({
        queryKey: [QueryKeys.questionnaireAnswer, id],
        queryFn: async () => {
            const result: IQuestionnaireAnswer = await QuestionnaireAnswerApi.getQuestionnaireAnswerByTaskId(id!);
            return new QuestionnaireAnswer(result);
        },
        enabled: !!id,
        staleTime: 3600000, //1h
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchInterval: false,
    });
}
